import { useCallback } from 'react';
import { downloadBlob } from 'helper/downloadFile';
/* eslint-disable-next-line import/no-extraneous-dependencies */
import domtoimage from 'dom-to-image-more';

export const BOTTOM_PADDING = 30;

export default function useDownloadDivImage(
  imageDivRef: React.RefObject<HTMLDivElement | null>,
  bottomPadding = BOTTOM_PADDING,
) {
  const downloadChartsAsImage = useCallback((filename: string) => () => {
    const imageDiv = imageDivRef.current;

    if (!imageDiv) return;

    // Exporta como está na tela: no escuro, texto e gráficos estão claros, então o fundo da imagem
    // é a superfície do tema atual (um `white` fixo deixaria o texto invisível).
    const fundo = getComputedStyle(imageDiv).getPropertyValue('--ee-bg-surface').trim() || 'white';

    domtoimage.toBlob(imageDivRef.current, {
      bgcolor: fundo,
      width: imageDiv.getBoundingClientRect().width,
      height: imageDiv.getBoundingClientRect().height + bottomPadding,
    }).then((blob: Blob) => {
      downloadBlob(blob, filename);
    });
  }, [imageDivRef, bottomPadding]);

  return downloadChartsAsImage;
}
